import React, { Children } from 'react';
import { motion } from 'framer-motion';
const containerVariants = {
  hidden: {},
  visible: {
    transition: {
      staggerChildren: 0.1
    }
  }
};
const statVariants = {
  hidden: {
    opacity: 0,
    scale: 0.9
  },
  visible: {
    opacity: 1,
    scale: 1,
    transition: {
      duration: 0.5,
      ease: [0.25, 0.46, 0.45, 0.94]
    }
  }
};
const borderColors = ['border-t-crimson', 'border-t-cobalt', 'border-t-emerald', 'border-t-saffron', 'border-t-crimson', 'border-t-cobalt'];
export function JurisdictionCoverage() {
  return <section className="w-full bg-midnight px-4 md:px-8 lg:px-16 py-20 md:py-32" data-id="element-174">
      <div className="max-w-7xl mx-auto" data-id="element-175">
        <h2 className="font-heading font-bold text-ivory uppercase text-3xl sm:text-4xl md:text-6xl lg:text-7xl tracking-tight mb-16 md:mb-24" data-id="element-176">
          JURISDICTION
          <br data-id="element-177" />
          <span className="text-emerald" data-id="element-178">COVERAGE</span>
        </h2>

        <motion.div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-0" variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-80px'
      }} data-id="element-179">
          <motion.div className={`border-2 border-ivory/20 border-t-4 ${borderColors[0]} p-6 md:p-8 text-center`} variants={statVariants} data-id="element-180">
            <span className="font-heading font-bold text-ivory text-4xl md:text-5xl lg:text-6xl block" data-id="element-181">
              50+
            </span>
            <span className="font-body text-ivory/60 text-sm md:text-base mt-2 block uppercase tracking-wider" data-id="element-182">
              Jurisdictions Covered
            </span>
          </motion.div>

          <motion.div className={`border-2 border-ivory/20 border-t-4 ${borderColors[1]} p-6 md:p-8 text-center`} variants={statVariants} data-id="element-183">
            <span className="font-heading font-bold text-ivory text-4xl md:text-5xl lg:text-6xl block" data-id="element-184">
              30+
            </span>
            <span className="font-body text-ivory/60 text-sm md:text-base mt-2 block uppercase tracking-wider" data-id="element-185">
              Languages Supported
            </span>
          </motion.div>

          <motion.div className={`border-2 border-ivory/20 border-t-4 ${borderColors[2]} p-6 md:p-8 text-center`} variants={statVariants} data-id="element-186">
            <span className="font-heading font-bold text-ivory text-4xl md:text-5xl lg:text-6xl block" data-id="element-187">
              200+
            </span>
            <span className="font-body text-ivory/60 text-sm md:text-base mt-2 block uppercase tracking-wider" data-id="element-188">
              Regulatory Frameworks
            </span>
          </motion.div>

          <motion.div className={`border-2 border-ivory/20 border-t-4 ${borderColors[3]} p-6 md:p-8 text-center`} variants={statVariants} data-id="element-189">
            <span className="font-heading font-bold text-ivory text-4xl md:text-5xl lg:text-6xl block" data-id="element-190">
              99.7%
            </span>
            <span className="font-body text-ivory/60 text-sm md:text-base mt-2 block uppercase tracking-wider" data-id="element-191">
              Compliance Accuracy
            </span>
          </motion.div>

          <motion.div className={`border-2 border-ivory/20 border-t-4 ${borderColors[4]} p-6 md:p-8 text-center`} variants={statVariants} data-id="element-192">
            <span className="font-heading font-bold text-ivory text-4xl md:text-5xl lg:text-6xl block" data-id="element-193">
              3wk
            </span>
            <span className="font-body text-ivory/60 text-sm md:text-base mt-2 block uppercase tracking-wider" data-id="element-194">
              Avg. Market Entry
            </span>
          </motion.div>

          <motion.div className={`border-2 border-ivory/20 border-t-4 ${borderColors[5]} p-6 md:p-8 text-center`} variants={statVariants} data-id="element-195">
            <span className="font-heading font-bold text-ivory text-4xl md:text-5xl lg:text-6xl block" data-id="element-196">
              €0
            </span>
            <span className="font-body text-ivory/60 text-sm md:text-base mt-2 block uppercase tracking-wider" data-id="element-197">
              Client Fines
            </span>
          </motion.div>
        </motion.div>
      </div>
    </section>;
}